module.exports = __webpack_public_path__ + "img/search_nodata.75a8c21d.png";